import React from 'react';
import {Card, Grid} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

import Checkbox from '@/components/form/checkbox';

const useStyles = makeStyles({
  root: {
    padding: 10,
    marginTop: 10,
  },
});

const DisabledCard = () => {
  const classes = useStyles();

  return (
    <Card className={classes.root}>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <Checkbox name='disabled' label='Disabled' />
        </Grid>
      </Grid>
    </Card>
  );
};

export default DisabledCard;
